/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('VerifyAccount', {
  ResendVerification: 'Your verification email has been resent!'
});
